import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { DataService } from './data.service';
import * as sha256 from 'sha256';
import * as forge from 'node-forge';
//import { environment } from 'src/environments/environment';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { Router } from '@angular/router';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import cookies from 'js-cookie';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
import {  } from './encrypt-decrypt.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private dataService: DataService, private _http: HttpClient, private commonService: CommonService, private router: Router, private encryptDecryptService: EncryptDecryptService,private memorystore: MemoryStorageService,private encryptDecryptservice: EncryptDecryptService) { }
  // public login_IAM(userInfo: any): Observable<any> {

  //   const body = {
  //     "user_name": userInfo.username,
  //   };

  //   return this.dataService.postData("Authentication/createSession", body, null, this.dataService.apiURL_IAM).pipe(
  //     map(res => {
  //       return res;
  //     }),
  //   );
  // }

  public login_LDAP(userInfo: any): Observable<any> {

    const body = {
      "userName": userInfo.username,
      "password": userInfo.password
    };

    if (this.dataService.Mandatory_To_Encrypt_PD == "YES") {
      if (this.dataService.Authentication_Type == "IAM-LDAP") {
        body.password = this.IAM_LDAP_Password_Encrypt(body.password);
      }
    }
    return this.dataService.postData("Authenticate", body, this.dataService.apiURL_Authentication).pipe(
      map(res => {
        return res;
      }),
    );
  }

  public login_IAM(loginInfo: any): Observable<any> {

    const body = {
      "userId": loginInfo.id,
      "userName": loginInfo.name,
      "ts": loginInfo.ts,
      "action": loginInfo.action,
      "contextName": "AP Workflow",
      "guid": loginInfo.guid,
      "token": loginInfo.token,
    };

    return this.dataService.postData("Authenticate", body, this.dataService.apiURL_Authentication).pipe(
      map(res => {
        return res;
      }),
    );
  }

  public getAuthorizedData(): Observable<any> {
    //changed getData to post
    let bodydata = {
      //  pwm_id:  this.encryptDecryptService.encryptUsingAES256(this.commonService.getUserInfoFromLocalStorage('userId'))
      pwm_id: this.encryptDecryptService.encryptUsingAES256(this.memorystore.getItem('userId')),
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };
    return this.dataService.postData("authorization", bodydata).pipe(
      map(res => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          return res.data;
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }),
    );
  }

  public Logout(): Observable<any> {

    const body = {
      // "LogonLogoffDetailsId": this.commonService.getUserInfoFromLocalStorage("logonLogoffDetailsId")
      "LogonLogoffDetailsId": this.memorystore.getItem("logonLogoffDetailsId")
    };
    this.dataService.postData("login/logout", body).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        localStorage.clear();
        this.commonService.detecookie();
        this.memorystore.clear();
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

    const obj = new Observable(o => {
      o.next(true);
    });

    return obj;
  }

  public getPWMUser(userName: any): Observable<any> {
    // let params = new HttpParams();
    // params = params.append("userName", userName);

    let body = {
      username: userName
    };

    return this.dataService.postData("pwm-user-ldap", body).pipe(
      map(res => {
        return res;
      }),
    );
  }

  public acceptPrivacyPolicy(userId: number): Observable<any> {
    let body = {
      user_id: userId
    };

    return this.dataService.postData("accept-privacy-policy", body).pipe(
      map(res => {
        return res;
      }),
    );
  }

  // USE FOR CELLC TEMP
  // public getPWMUser(userName: any): Observable<any> {
  //   const body = {
  //     "user_name": userName
  //   }

  //   return this.dataService.postData("pwm-user", body).pipe(
  //     map(res => {
  //       return res;
  //     }),
  //   );
  // }

  public validateSession(): any {
    const body = {
      "token": localStorage.getItem("token")
    };
    return this.dataService.postData('Authentication/session/validate', body, this.dataService.apiURL_Authentication)
      .pipe(
        map(res => {
          return res;
        }),
      );
  }

  public IAM_LDAP_Password_Encrypt(password: string): string {
    var pki = forge.pki; //create a public key object
    var publicKey = pki.publicKeyFromPem(environment.IAM_publicKey); //adding a public key to the object
    //apply the ‘RSA-OAEP’
    var LDAPencrypted = publicKey.encrypt(password, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha1.create()
      }
    });
    password = forge.util.encode64(LDAPencrypted);

    return password;
  }

  public csrfRefresh() {
    return this.dataService.postData("login/csrf-refresh", {}).toPromise();
  }

  public killUserSession(id): Observable<any> {
    let param = new HttpParams;
    param = param.append("LogOnLogOffId", id);
    param = param.append("IsAddNew", "true");
    param = param.append("ApplicationName", "PI");

    return this.dataService.getData("kill-user-session", param).pipe(
      map(res => {
        return res;
      }),
    );
  }
}
